import { createSlice } from "@reduxjs/toolkit";
import {
  getAllParameters,
  getAllDocumentTemplates,
  deleteTemplate,
  addTemplate,
  updateTemplate,
  getParameterValues,
} from "../../Api/services/documentTemplatesService";
import toast from "react-hot-toast";
import { t } from "../../utils/common/i18nHelper";

const templatesSlice = createSlice({
  name: "templates",
  initialState: {
    templates: [],
    totalTemplates: 0,
    parameters: [],
    parameterValues: [],
    totalParameters: 0,
    error: null,
    loading: false,
    addOrEditStatus: null,
  },
  extraReducers: (builder) => {
    //get parameters list
    builder
      .addCase(getAllParameters.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllParameters.fulfilled, (state, action) => {
        if (!action?.payload?.success) {
          toast.error(action.payload.message);
        }
        return {
          ...state,
          parameters: action.payload.data.data,
          totalParameters: action.payload.data.total_count,
          loading: false,
        };
      })
      .addCase(getAllParameters.rejected, (state, action) => {
        toast.error(action.payload);

        return {
          ...state,
          loading: false,
          error: action.payload.message,
        };
      })
      // get parameter values
      .addCase(getParameterValues.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getParameterValues.fulfilled, (state, action) => {
        return {
          ...state,
          parameterValues: action?.payload,
          loading: false,
        };
      })
      .addCase(getParameterValues.rejected, (state, action) => {
        toast.error(action.payload);

        return {
          ...state,
          loading: false,
          error: action?.payload,
        };
      })
      // getAllDocumentTemplates
      .addCase(getAllDocumentTemplates.pending, (state) => {
        return {
          ...state,
          loading: true,
          addOrEditStatus: null,
        };
      })
      .addCase(getAllDocumentTemplates.fulfilled, (state, action) => {
        if (!action?.payload?.success) {
          toast.error(action.payload.message);
        }
        return {
          ...state,
          templates: action.payload.data.templates,
          totalTemplates: action.payload.data.total_count,
          loading: false,
        };
      })
      .addCase(getAllDocumentTemplates.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload.message,
        };
      })
      // Delete template
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        if (!action?.payload?.success) {
          toast.error(action.payload.message);
        }
        toast.success(t("document_templates.delete_success"));
        return {
          ...state,
          templates: action.payload.templates.filter(
            (temp) => temp.id !== action.payload.id
          ),
          totalTemplates: action.payload.totalTemplates - 1,
          loading: false,
        };
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload.message,
        };
      })
      // add template
      .addCase(addTemplate.pending, (state, action) => {
        return {
          ...state,
          addOrEditStatus: "pending",
        };
      })
      .addCase(addTemplate.fulfilled, (state, action) => {
        toast.success(t("document_templates.add_success"));
        return {
          ...state,
          addOrEditStatus: "success",
        };
      })
      .addCase(addTemplate.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          addOrEditStatus: "success",
        };
      })
      // edit template
      .addCase(updateTemplate.pending, (state, action) => {
        return {
          ...state,
          addOrEditStatus: "pending",
        };
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        toast.success(t("document_templates.edit_success"));
        return {
          ...state,
          loading: false,
          error: action.payload.message,
          addOrEditStatus: "success",
        };
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload.message,
        };
      });
  },
});

export default templatesSlice.reducer;
